import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import SchoolSerializer from '@linc-technologies/linced-common/serializers/school';

export default class School extends SchoolSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    optionSetIds: { serialize: 'ids' },
  };
}
